module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/cont.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9781607052302_06_pref#a1"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")]), _vm._v(" —A Story of Creative Inspiration from the Imagination of My Brother, Shane Haggard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_07_ch1#a2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 1: Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_08_ch2#a3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 2: Choosing Fabrics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_09_ch3#a4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 3: Creating a Look")]), _vm._v(" "), _c('b', [_vm._v("£")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_10_ch4#a5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 4: Adding the History")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_10_ch4#b1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selecting, Scanning, and Printing Photographs on Fabric")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_10_ch4#b2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Manipulating Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_10_ch4#b3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Legacy, the Lineage—Labeling Your Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#a6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 5: Design and Layout")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Layout Options")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stylizing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foundation Piecing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Squaring and Finishing Blocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sewing Blocks Together without Sashing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashing and Borders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_11_ch5#b10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Binding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#a7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 6: Embellishing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#b11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trims")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#b12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#b13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#b14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jewelry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_12_ch6#b15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artistic Flair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#a8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" 7: Stitching Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Design and Drawing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Threads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Basic Stitches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Knot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Knot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Daisy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brian’s Y Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brian’s Asterisk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttonhole Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outline/Stem Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cretan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Featherstitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japanese Ribbon Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Combination Stitches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double-Tacked Lazy Daisy Flower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fishbone with Center Rib Stitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detailed Leaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woven Pinwheel Flower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lattice Sunflower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby’s Breath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Larkspur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stitched Medallion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wheat Stem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flower Patch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cotton Ribbon Medallion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#c24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Felt Appliqué")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Projects")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Great-Grandmas Pillow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ladies of the Past")]), _vm._v(" wallhanging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Children of the Past")]), _vm._v(" table runner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Timeless Memories")]), _vm._v(" wallhanging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("For the Love of Mother")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Love Letters")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Etta May’s Special Day")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b27",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Button, Button, Who’s Got the Button?")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b28",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Family Legacy")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13_ch7#b29",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Silken Tribute")]), _vm._v(" quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_13a_photo#a9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Photo Gallery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_14_design#a10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Design Inspiration")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9781607052302_15_abt#a11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40c3c3bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607052302_04_toc.vue
// module id = 66
// module chunks = 0